import React from "react";
import { Row, Col, Form } from "react-bootstrap";
import FileUploadField from "../../../Common/FileUploadField";
import ImagePlaceholder from "../../../assets/img/img_placeholder.png";
import X from "../../../assets/img/x.png";

export default function BankDetailsSection({
  employeeData,
  handleInputChange,
  errors,
  deleteFile,
  photoLoad,
  chequePhoto,
  preventLeadingSpace,
}) {
  return (
    <Row>
      <Col md={4}>
        <Form.Group>
          <Form.Label style={{ color: "#334d6e" }}>Bank Name</Form.Label>
          <Form.Control
            type="text"
            name="bank_name"
            className="  text-muted"
            value={employeeData.bank_name}
            onChange={(e) => handleInputChange(e, "employee")}
            onKeyDown={preventLeadingSpace}
            isInvalid={!!errors.bank_name}
          />
          <Form.Control.Feedback type="invalid">
            {errors.bank_name}
          </Form.Control.Feedback>
        </Form.Group>
      </Col>
      <Col md={4}>
        <Form.Group>
          <Form.Label style={{ color: "#334d6e" }}>
            Bank Account Number
          </Form.Label>
          <Form.Control
            className="  text-muted"
            type="text"
            name="bank_account_number"
            value={employeeData.bank_account_number}
            onChange={(e) => {
              const numericValue = e.target.value.replace(/[^0-9]/g, "");
              handleInputChange(
                {
                  target: { name: "bank_account_number", value: numericValue },
                },
                "employee"
              );
            }}
            onKeyDown={preventLeadingSpace}
            isInvalid={!!errors.bank_account_number}
          />
          <Form.Control.Feedback type="invalid">
            {errors.bank_account_number}
          </Form.Control.Feedback>
        </Form.Group>
      </Col>
      <Col md={4}>
        <Form.Group>
          <Form.Label style={{ color: "#334d6e" }}>
            Account Holder Name
          </Form.Label>
          <Form.Control
            type="text"
            className="  text-muted"
            name="account_holder_name"
            value={employeeData.account_holder_name}
            onChange={(e) => handleInputChange(e, "employee")}
            onKeyDown={preventLeadingSpace}
            isInvalid={!!errors.account_holder_name}
          />
          <Form.Control.Feedback type="invalid">
            {errors.account_holder_name}
          </Form.Control.Feedback>
        </Form.Group>
      </Col>
      <Col md={4}>
        <Form.Group>
          <Form.Label style={{ color: "#334d6e" }}>IFSC Code</Form.Label>
          <Form.Control
            type="text"
            className="  text-muted"
            name="ifsc_code"
            value={employeeData.ifsc_code}
            onChange={(e) => handleInputChange(e, "employee")}
            onKeyDown={preventLeadingSpace}
            isInvalid={!!errors.ifsc_code}
          />
          <Form.Control.Feedback type="invalid">
            {errors.ifsc_code}
          </Form.Control.Feedback>
        </Form.Group>
      </Col>
      {/* <Col md={4}>
        <Form.Group>
          <Form.Label style={{ color: "#334d6e" }}>
            Bank Document Type
          </Form.Label>
          <Form.Select
            className="  text-muted"
            name="bank_document_type"
            value={employeeData.bank_document_type}
            onChange={(e) => handleInputChange(e, "employee")}
            isInvalid={!!errors.bank_document_type}
          >
            <option value="">Select Document Type</option>
            <option value="Passbook">Passbook</option>
            <option value="Cheque">Cancelled Cheque</option>
            <option value="BankStatement">Bank Statement</option>
          </Form.Select>
          <Form.Control.Feedback type="invalid">
            {errors.bank_document_type}
          </Form.Control.Feedback>
        </Form.Group>
      </Col> */}
      <Col md={4}>
        <Form.Group>
          <Form.Label style={{ color: "#334d6e" }}>
            Upload Cancelled Cheque Photo*
          </Form.Label>
          <FileUploadField
            name="bank_document_upload"
            value={employeeData.bank_document_upload}
            onChange={(e) => handleInputChange(e, "employee")}
            onDelete={() => deleteFile("bank_document_upload")}
            error={errors.bank_document_upload}
            isLoading={photoLoad}
            placeholder={ImagePlaceholder}
            deleteIcon={X}
          />
        </Form.Group>
      </Col>
    </Row>
  );
}
